module.exports = __webpack_public_path__ + "static/BakingBanner-04-6125a53b176e3fdb509a5882a1247462.png";